<template>
    <div>
        <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
            <div class="w-12 h-12 border-b-2 rounded-full animate-spin border-custom-yellow"></div>
        </div>
        <template v-else>
            <div class="relative mt-5 overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-left text-gray-700 rtl:text-right">
                    <thead>
                        <tr class="bg-gray-100">
                            <th scope="col" class="p-4">
                                <div class="flex items-center">
                                    <input id="checkbox-all-search" type="checkbox"
                                        class="w-4 h-4 bg-gray-100 border-gray-300 rounded text-custom-yellow focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                    <label for="checkbox-all-search" class="sr-only">checkbox</label>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Serial no.
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Donor Name
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Blood Group
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Volume
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Type of Donation
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Donation Process
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Donation Date
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Donated To
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                <div class="flex items-center">
                                    Status
                                    <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                        </svg></a>
                                </div>
                            </th>
                            <th scope="col" class="px-6">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(donation, index) in donations" :key="donation.donation_id"
                            class="border-b">
                            <td class="w-4 p-4">
                                <div class="flex items-center">
                                    <input :id="'checkbox-table-search-' + index" type="checkbox" class="w-4 h-4">
                                    <label :for="'checkbox-table-search-' + index" class="sr-only">checkbox</label>
                                </div>
                            </td>
                            <td class="px-6 py-2">{{ donation.pint_serial }}</td>
                            <td class="px-6 py-2">{{ donation.donor.user.first_name }} {{ donation.donor.user.last_name
                                }}
                            </td>
                            <td class="px-6 py-2">{{ donation.donor?.user?.blood_group_id?.description ?? 'Unknown' }}
                            </td>
                            <td class="px-6 py-2">{{ donation.quantity ?? '0' }} ml</td>
                            <td class="px-6 py-2">{{ donation.donation_type }} </td>
                            <td class="px-6 py-2">{{ donation.technology }} </td>
                            <td class="px-6 py-2">{{ new Date(donation.date_added).toLocaleString() }}</td>
                            <td class="px-6 py-2">{{ donation.donor.patient ?? 'N/A' }} </td>
                            <td class="px-6 py-2">

                                <span class="px-2 py-1 rounded" :class="{
                                    'text-red-500 bg-red-100': ['Unscreened', 'Disposed', 'Pending Disposal'].includes(getDonationStatus(donation)),
                                    'text-green-500 bg-green-100': ['Pending Approval', 'Ongoing Screening'].includes(getDonationStatus(donation)),
                                    'text-orange-500 bg-orange-100': ['Approved', 'Split', 'Requote', 'Leuco-reduction'].includes(getDonationStatus(donation))
                                }">
                                    {{ getDonationStatus(donation) }}
                                </span>
                            </td>
                            <td class="flex items-center px-6 py-2">
                                <template
                                    v-if="getDonationStatus(donation) === 'Unscreened' || getDonationStatus(donation) === 'Ongoing Screening'">
                                    <CustomButton label="Screen" @click="handleScreen(donation.blood_donation_id)"
                                        bg-class="justify-center w-24 py-2 text-sm bg-custom-yellow" />
                                </template>
                                <template v-if="getDonationStatus(donation) === 'Pending Approval'">
                                    <CustomButton label="Approve" @click="handleApprove(donation.blood_donation_id)"
                                        bg-class="py-2 text-sm bg-custom-yellow" />
                                </template>
                                <template v-if="getDonationStatus(donation) === 'Pending Disposal'">
                                    <CustomButton label="Dispose" @click="handleDispose(donation.blood_donation_id)"
                                        bg-class="py-2 text-sm bg-red-400" />
                                </template>
                                <template
                                    v-if="getDonationStatus(donation) === 'Approved' || getDonationStatus(donation) === 'Disposed' || getDonationStatus(donation) === 'Split' || getDonationStatus(donation) === 'Requote' || getDonationStatus(donation) === 'Leuco-reduction'">
                                    <CustomButton label="View Details"
                                        @click="handleViewDetails(donation.blood_donation_id)"
                                        :disabled="isLoading[donation.blood_donation_id]"
                                        :bg-class="isLoading[donation.blood_donation_id] ? 'bg-gray-500 cursor-not-allowed text-xs' : 'bg-custom-yellow text-xs py-1'" />
                                </template>
                                <CustomButton label="Donation sticker"
                                    @click="handlePrintSticker(donation.blood_donation_id)"
                                    :disabled="isLoading[donation.blood_donation_id]"
                                    :bg-class="isLoading[donation.blood_donation_id] ? 'bg-gray-500 cursor-not-allowed text-xs' : 'bg-custom-blue text-xs py-1 ml-2'" />
                                <CustomButton label="Resend Donation" v-if="facility_code === 'TNH001'"
                                    @click="handleResendLabwareDonation(donation.blood_donation_id)"
                                    :disabled="isLoading[donation.blood_donation_id]"
                                    :bg-class="isLoading[donation.blood_donation_id] ? 'bg-gray-500 cursor-not-allowed text-xs' : 'bg-gray-500 text-xs py-1 ml-2'" />
                                <div v-if="isLoading[donation.blood_donation_id]"
                                    class="w-5 h-5 ml-2 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin">
                                </div>

                            </td>

                        </tr>
                        <tr v-if="loadingMore">
                            <td colspan="10" class="py-4 text-center">
                                <div class="flex items-center justify-center">
                                    <div class="w-8 h-8 border-b-2 rounded-full animate-spin border-custom-yellow"></div>
                                    <span class="ml-2 text-gray-600">Loading more donations...</span>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="!hasMore && donations.length > 0 && !loadingMore">
                            <td colspan="10" class="py-4 text-center text-gray-500">
                                No more donations to load
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mb-2 text-center text-gray-600">{{ showingText }}</p>
            <div class="flex justify-center gap-4 mt-4">
                <button @click="previousPage" :disabled="currentPage === 1"
                    class="flex items-center gap-2 px-6 py-3 font-bold text-center align-middle transition-all rounded-lg select-none text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                    type="button">
                    <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m15 19-7-7 7-7" />
                    </svg>
                    Previous
                </button>

                <div class="flex items-center gap-2">
                    <button v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="{
                        'bg-custom-blue text-white': page === currentPage,
                        'text-custom-blue': page !== currentPage
                    }" class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                        type="button">
                        <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                            {{ page }}
                        </span>
                    </button>
                </div>

                <button @click="nextPage" :disabled="currentPage === totalPages"
                    class="flex items-center gap-2 px-6 py-3 font-bold text-center align-middle transition-all rounded-lg select-none text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                    type="button">
                    Next
                    <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m9 5 7 7-7 7" />
                    </svg>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';
import api from '@/services/api';
import SweetAlertService from '@/services/SweetAlertService';
// import hospitalLogo from '@/assets/images/Jiji-Health-Blue-Logo.png';
import JsBarcode from 'jsbarcode'

export default {
    name: 'BloodUnitsTab',
    components: {
        CustomButton,
    },

    props: {
        searchQuery: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            currentPage: 1,
            totalPages: 0,
            totalCount: 0,
            perPage: 10,
            loading: false,
            loadingMore: false,
            hasMore: true,
            debounceTimer: null,
            donations: [],
            isLoading: {},
            error: null,
            userData: [],
            filters: {
                bloodGroup: "",
                dateRegistered: '',
                donationProcess: '',
                status: '',
            },
            facility_code: ''
        }
    },

    created() {
        this.getBloodUnitDonations();
    },

    mounted() {
        this.userData = this.$store.getters["auth/user"];
        if(this.userData){
            this.facility_code =  this.userData.user_roles[0].facility_department.facility.facility_code
        }
        this.facility_logo = this.userData.user_roles[0]?.facility_department?.facility?.logo;
        this.loadInitialDonations();
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    computed: {
        visiblePages() {
            return this.calculatePageRange();
        },
        showingText() {
            if (this.loading && this.donations.length === 0) return "Loading...";
            if (this.donations.length === 0) return "No donations found";
            const end = this.donations.length;
            return `Showing 1-${end} of ${this.totalCount}`;
        }
    },

    watch: {
        filters: { deep: true, handler: 'loadInitialDonations' },
        searchQuery: {
            handler() {
                clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(() => {
                    this.loadInitialDonations();
                }, 300);
            }
        }
    },

    methods: {

        applyFilters(filters) {
            this.filters = { ...this.filters, ...filters };
            this.currentPage = 1;
        },

        resetFilters() {
            this.filters = {
                bloodGroup: "",
                dateRegistered: '',
                donationProcess: '',
                status: "",
            };
            this.currentPage = 1;
        },

        async handleScreen(donationId) {
            this.isLoading[donationId] = true;
            try {
                await new Promise(resolve => setTimeout(resolve, 500));
                if (donationId) {
                    this.$router.push({
                        name: 'UnitScreeningForm',
                        params: { blood_donation_id: donationId }
                    });
                } else {
                    console.error('Invalid donationId');
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading[donationId] = false; // Reset loading state
            }
        },


        async handleViewDetails(donationId) {
            this.isLoading[donationId] = true;
            try {
                await new Promise(resolve => setTimeout(resolve, 500));
                this.$router.push({
                    name: 'UnitDetailsPage',
                    params: { blood_donation_id: donationId }
                });
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading[donationId] = false; // Reset loading state
            }
        },

        async handleApprove(donationId) {
            try {
                await api.confirmScreening(donationId);
                await SweetAlertService.showSuccess('Success!', 'Blood Unit approved successfully!');
                this.$router.go(0);
            } catch (error) {
                this.error = error.message || 'Failed to confirm screening';
            }
        },

        async handleDispose(donationId) {
            try {
                await api.disposeScreening(donationId);
                await SweetAlertService.showSuccess('Success!', 'Blood Unit disposed successfully!');
                this.$router.go(0);
            } catch (error) {
                this.error = error.message || 'Failed to dispose screening';
            }
        },

        async getBloodUnitDonations() {
            this.loading = true;
            try {
                const queryParams = { ...this.filters, search_query: this.searchQuery, page: this.currentPage, per_page: this.perPage };
                const response = await api.getBloodDonations(queryParams);
                this.donations = response.data || response;
                this.currentPage = response.current_page;
                this.totalPages = response.total_pages;
                this.totalCount = response.total_count || this.totalPages * this.perPage;
                this.hasMore = this.currentPage < this.totalPages;
                console.log('data:', this.donations);
            } catch (error) {
                this.error = error.message || 'Failed to fetch donations';
            } finally {
                this.loading = false;
            }
        },

        resetPagination() {
            this.currentPage = 1;
            this.totalPages = 0;
            this.totalCount = 0;
            this.donations = [];
            this.hasMore = true;
        },

        handleScroll() {
            if (this.loadingMore || !this.hasMore) return;

            const scrollPosition = window.innerHeight + window.scrollY;
            const threshold = document.body.offsetHeight - 200;

            if (scrollPosition >= threshold) {
                this.loadMore();
            }
        },

        async loadInitialDonations() {
            this.loading = true;
            this.resetPagination();
            try {
                const queryParams = { ...this.filters, search_query: this.searchQuery, page: 1, per_page: this.perPage };
                const response = await api.getBloodDonations(queryParams);
                this.donations = response.data || response;
                this.currentPage = response.current_page;
                this.totalPages = response.total_pages;
                this.totalCount = response.total_count || this.totalPages * this.perPage;
                this.hasMore = this.currentPage < this.totalPages;
            } catch (error) {
                this.error = error.message || 'Failed to fetch donations';
            } finally {
                this.loading = false;
            }
        },

        async loadMore() {
            if (this.loadingMore || !this.hasMore) return;

            this.loadingMore = true;
            try {
                const nextPage = this.currentPage + 1;
                const queryParams = { ...this.filters, search_query: this.searchQuery, page: nextPage, per_page: this.perPage };
                const response = await api.getBloodDonations(queryParams);
                this.donations = [...this.donations, ...(response.data || response)];
                this.currentPage = response.current_page;
                this.totalPages = response.total_pages;
                this.totalCount = response.total_count || this.totalPages * this.perPage;
                this.hasMore = this.currentPage < this.totalPages;
            } catch (error) {
                this.error = error.message || 'Failed to fetch more donations';
            } finally {
                this.loadingMore = false;
            }
        },

        async fetchPage(page) {
            this.loading = true;
            try {
                const queryParams = { ...this.filters, search_query: this.searchQuery, page: page, per_page: this.perPage };
                const response = await api.getBloodDonations(queryParams);
                this.donations = response.data || response;
                this.currentPage = response.current_page;
                this.totalPages = response.total_pages;
                this.totalCount = response.total_count || this.totalPages * this.perPage;
                this.hasMore = this.currentPage < this.totalPages;
            } catch (error) {
                this.error = error.message || 'Failed to fetch donations';
            } finally {
                this.loading = false;
            }
        },

        async handleResendLabwareDonation(blood_donation_id) {
            try {
                const payload = {
                    donation_id: blood_donation_id
                }
                await api.resendDonationTNH(payload);
                SweetAlertService.showSuccess(
                    "Confirmation Recorded",
                    `Donation resend to labware successfully`
                );
            } catch (error) {
                console.error("Error resending donation", error);
                SweetAlertService.showError("Error", "Error resending donation.");
            }
        },

        calculatePageRange() {
            const maxPagesToShow = 5;
            let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
            let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

            // Adjust start page if we're near the end
            if (endPage - startPage + 1 < maxPagesToShow) {
                startPage = Math.max(1, endPage - maxPagesToShow + 1);
            }

            return Array.from(
                { length: endPage - startPage + 1 },
                (_, i) => startPage + i
            );
        },

        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.fetchPage(page);
            }
        },
        async previousPage() {
            if (this.currentPage > 1) {
                await this.fetchPage(this.currentPage - 1);
            }
        },
        async nextPage() {
            if (this.currentPage < this.totalPages) {
                await this.fetchPage(this.currentPage + 1);
            }
        },

        calculateDaysRemaining(expiryDate) {
            const today = new Date();
            const expiry = new Date(expiryDate);
            const timeDiff = expiry - today;
            return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        },

        allTestsConfirmed(donation) {
            const tests = [
                donation.screening_test?.hepatitis_b,
                donation.screening_test?.hepatitis_c,
                donation.screening_test?.hiv,
                donation.screening_test?.vdrl,
                donation.screening_test?.malaria,
                donation.screening_test?.blood_clot
            ];

            return tests.every(test => test !== null && test !== '');
        },



        checkForPendingDisposal(donation) {
            const tests = {
                hepatitis_b: donation.screening_test?.hepatitis_b,
                hepatitis_c: donation.screening_test?.hepatitis_c,
                hiv: donation.screening_test?.hiv,
                vdrl: donation.screening_test?.vdrl,
                malaria: donation.screening_test?.malaria,
                blood_clot: donation.screening_test?.blood_clot
            };

            // Check for blood_clot and vdrl custom values
            if (tests.blood_clot === "Yes" || tests.vdrl === "Reactive") {
                return true;
            }

            // Check if any other test is positive
            const otherTestResults = [
                tests.hepatitis_b,
                tests.hepatitis_c,
                tests.hiv,
                tests.malaria,
            ];

            return otherTestResults.includes("Positive");
        },

        getDonationStatus(donation) {
            if (donation.screening_logs) {
                const logsWithConfirmedBy = donation.screening_logs.filter(log => log.confirmed_by?.user_id !== null);

                if (this.checkForPendingDisposal(donation) && logsWithConfirmedBy.length === 6 && this.allTestsConfirmed(donation) && donation.unit_product_id !== null && donation.blood_group_id !== null && donation.expiry_date !== null && donation.pint_serial !== null && donation.origin !== null && donation.approved_by === null) {
                    return 'Pending Disposal';
                }
                else if (logsWithConfirmedBy.length === 6 && donation.unit_product_id !== null && donation.blood_group_id && donation.expiry_date !== null && donation.pint_serial !== null && donation.origin !== null && this.allTestsConfirmed(donation) && donation.approved_by === null) {
                    return 'Pending Approval';
                } else {
                    return donation.status;
                }
            }
        },

        generateBarcode(pintSerial) {
            const canvas = document.createElement('canvas');
            JsBarcode(canvas, pintSerial, { format: 'CODE128' });
            return canvas.toDataURL('image/png');
        },

        async handlePrintSticker(donationId) {
            this.isLoading[donationId] = true;
            const printWindow = document.createElement('iframe');
            printWindow.style.position = 'absolute';
            printWindow.style.width = '0';
            printWindow.style.height = '0';
            document.body.appendChild(printWindow);

            try {
                await new Promise(resolve => setTimeout(resolve, 500));

                const donation = this.donations.find(d => d.blood_donation_id === donationId);
                if (!donation) {
                    throw new Error('Donation not found');
                }

                // Extract necessary details
                const donatedTo = donation.donor?.patient || 'N/A';
                const donationType = donation.donation_type || 'N/A';
                const bagNo = donation.pint_serial || 'N/A';
                const dateDonated = donation.created_at
                    ? new Date(donation.created_at).toLocaleDateString()
                    : 'N/A';
                const assignedNumber = donation.donor?.assigned_number || '';

                const barcodeSrc = this.generateBarcode(bagNo);

                // Prepare print content
                const printContent = `
        <div class="page-container">
          <div class="sticker-container">
            <div class="logo-container">
              <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
            </div>    
            <div class="donation-info">
                <div>
                <p>Donated To:<strong> ${donatedTo} </strong></p>
              </div>
              <div>
                <p>Donated Type:<strong> ${donationType} </strong></p>
              </div>
              <div>
                <p>Bag No:<strong> ${bagNo} </strong></p>
              </div>
              <div>
                <p>Donation Date:<strong>${ new Date(dateDonated).toLocaleString() }</strong></p>
              </div>
              ${assignedNumber ? `<div><p>Donor Number:<strong> ${assignedNumber} </strong></p></div>` : ''}
               
            </div>
            <div class="barcode-container">
              <img src="${barcodeSrc}" alt="Barcode" class="barcode">
            </div>
          </div>
          </div>
        `;

                // Prepare the full document for printing
                const printDocument = `
          <html>
          <head>
            <title>Print Preview</title>
            <style>
              body {
                font-family: Manjari, sans-serif;
                text-align: center;
                margin: 0;
                padding: 0;
              }
              .page-container {
                width: 100vw;
                height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .sticker-container {
                margin: auto;
                width: 500px;  /* Fixed width for the content */
                padding: 20px;
                background-color: white;
              }
              .logo-container {
                display: flex;
                justify-content: center;
                margin-bottom: 10px;
              }
              .logo {
                height: 100px;
              }
             
              .donation-info {
                margin-bottom: 10px;
              }
              .donation-info p {
                font-size: 20px;
              }
                .barcode-container {
                display: flex;
                justify-content: center;
                margin-bottom: 5px;
              }
              .barcode {
                width: 60%;
              }
             
              @media print {
                @page {
                  size: A8;
                  margin: 0;
                }
                body {
                  margin: 0;
                  padding: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  height: 100%;
                }
                .sticker-container {
                  width: auto;
                  margin: 0;
                  padding: 10px;
                }
              }
            </style>
          </head>
          <body>
            ${printContent}
          </body>
          </html>
        `;

                // Open the print document
                printWindow.contentDocument.open();
                printWindow.contentDocument.write(printDocument);
                printWindow.contentDocument.close();

                // Print when the document is loaded
                printWindow.contentWindow.onload = function () {
                    printWindow.contentWindow.print();
                };
            } catch (error) {
                this.error = error.message || 'Failed to fetch donation';
            } finally {
                this.isLoading[donationId] = false
            }
        },
    },
}
</script>


<style lang="css" scoped></style>